module.exports = __webpack_public_path__ + "static/media/right-web.3d84fbfe.svg";